import { GlobalAlert } from "."

export const GlobalActionComponent = () => {
    return <><GlobalAlert /></>
}